<template>
  <div class="text-center">
    <h3 class="mt-2 text-sm font-semibold text-gray-900">
      <slot />
    </h3>
  </div>
</template>
